<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <span style="font-size:20px; color: #fff;">ตารางสรุปจุดติดตั้งแต่ละสายทาง</span>
      </b-col>
      <b-col cols="12">
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(wid)="data">
            <div>
              <b-link
                v-if="data.item.sem_type == 'nbiot_cab_pole_hm_3p'"
                :to="{ path: `/semcontrol-detail?wid=${data.item.id}&type=${data.item.equipment}`}"
                style="text-decoration: underline; color: #11DF00;"
              >
                <span>ดูเพิ่มเติ่ม</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="24"
                />
              </b-link>
              <b-link
                v-if="data.item.sem_type == 'nbiot_cab_3p' || data.item.sem_type == 'nbiot_cab_3p_line_check_2w' || data.item.sem_type == 'nbiot_cab_3p_line_check_6w'"
                :to="{ path: `/SEMNB-iotCab3P?wid=${data.item.id}&type=${data.item.equipment}`}"
                style="text-decoration: underline; color: #11DF00;"
              >
                <span>ดูเพิ่มเติ่ม</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="24"
                />
              </b-link>
              <b-link
                v-if="data.item.sem_type == 'nbiot_cab_line_check_2w' || data.item.sem_type == 'nbiot_cab_line_check_4w' || data.item.sem_type === 'nbiot_cab_line_check_1w_r' || data.item.sem_type === 'nbiot_cab_line_check_1w_l' || data.item.sem_type === 'nbiot_cab_1p'"
                :to="{ path: `/semcontrol-detail1?wid=${data.item.id}&type=${data.item.equipment}`}"
                style="text-decoration: underline; color: #11DF00;"
              >
                <span>ดูเพิ่มเติ่ม</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="24"
                />
              </b-link>
              <b-link
                v-if="data.item.sem_type == 'lora_lighting'"
                :to="{ path: `/sem-detail?wid=${data.item.id}&type=${data.item.equipment}`}"
                style="text-decoration: underline; color: #11DF00;"
              >
                <span>ดูเพิ่มเติ่ม</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="24"
                />
              </b-link>
              <b-link
                v-if="data.item.sem_type == 'nbiot_cab_lora'"
                :to="{ path: `/nbiot-lora?wid=${data.item.id}&type=${data.item.equipment}`}"
                style="text-decoration: underline; color: #11DF00;"
              >
                <span>ดูเพิ่มเติ่ม</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="24"
                />
              </b-link>
            </div>
          </template>
          <template #cell(ISOnline)="data">
            <b-badge
              v-if="data.item.sem_type != 'lora_lighting'"
              :variant="ISOnline[1][data.value]"
            >
              {{ ISOnline[0][data.value] }}
            </b-badge>
            <b-badge
              v-if="data.item.sem_type === 'lora_lighting' & data.item.SemISOnline === 'Online'"
              variant="light-success"
            >
              ออนไลน์
            </b-badge>
            <b-badge
              v-if="data.item.sem_type === 'lora_lighting' & data.item.SemISOnline === 'Offline'"
              variant="light-danger"
            >
              ออฟไลน์
            </b-badge>
          </template>
          <template #cell(ISNormal)="data">
            <b-badge
              v-if="data.item.sem_type != 'lora_lighting' & data.item.sem_type != 'nbiot_cab_lora' & data.item.ISOnline == 'Offline'"
              variant="danger"
            >
              ผิดปกติ
            </b-badge>
            <b-badge
              v-if="data.item.sem_type != 'lora_lighting' & data.item.sem_type != 'nbiot_cab_lora' & data.item.issue_linecheck == null & data.item.issue_circuit == null & data.item.ISOnline == 'Online'"
              :variant="ISNormal[1][data.value]"
            >
              {{ ISNormal[0][data.value] }}
            </b-badge>
            <b-badge
              v-if="data.item.sem_type != 'lora_lighting' & data.item.sem_type != 'nbiot_cab_lora' & data.item.issue_linecheck == 0 & data.item.issue_circuit == 0 & data.item.ISOnline == 'Online'"
              variant="success"
            >
              ปกติ
            </b-badge>
            <b-badge
              v-if="data.item.sem_type != 'lora_lighting' & data.item.sem_type != 'nbiot_cab_lora' & data.item.issue_linecheck == 1 & data.item.issue_circuit == 0 & data.item.ISOnline == 'Online'"
              variant="danger"
            >
              สายขาด
            </b-badge>
            <b-badge
              v-if="data.item.sem_type != 'lora_lighting' & data.item.sem_type != 'nbiot_cab_lora' & data.item.issue_linecheck == 0 & data.item.issue_circuit == 1 & data.item.ISOnline == 'Online'"
              variant="danger"
            >
              วงจรผิดปกติ
            </b-badge>
            <b-badge
              v-if="data.item.sem_type != 'lora_lighting' & data.item.sem_type != 'nbiot_cab_lora' & data.item.issue_linecheck == 1 & data.item.issue_circuit == 1 & data.item.ISOnline == 'Online'"
              variant="danger"
            >
              วงจรผิดปกติและสายขาด
            </b-badge>
            <span
              v-if="data.item.sem_type === 'lora_lighting' || data.item.sem_type === 'nbiot_cab_lora'"
            >
              ทั้งหมด {{ data.item.Total }}
            </span>
          </template>
          <template #cell(lastupdate)="data">
            <span
              v-if="data.item.sem_type !== 'lora_lighting'"
            >
              {{ data.item.lastupdate }}
            </span>
            <span
              v-if="data.item.sem_type === 'lora_lighting'"
            >
              {{ data.item.sem_lastupdate }}
            </span>
          </template>
          <template #cell(Online)="data">
            {{ data.item.Total - data.item.Offline }}
          </template>
          <template #cell(Offline)="data">
            {{ data.value }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BLink, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BLink,
    BBadge,
  },
  data() {
    return {
      fields: [
        {
          key: 'detail',
          label: 'จุดติดตั้ง',
          class: 'text-center',
        },
        {
          key: 'ISNormal',
          label: 'สถานะ',
          class: 'text-center',
          sortable: false,
        },
        {
          key: 'ISOnline',
          label: 'การเชื่อมต่อ',
          class: 'text-center',
          sortable: false,
        },
        {
          key: 'lastupdate',
          label: 'อัพเดตล่าสุด',
          class: 'text-center',
          sortable: true,
        },
        {
          key: 'wid',
          label: 'รายละเอียด',
          class: 'text-center',
        },
      ],
      items: [],
      perPage: 100,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      ISOnline: [{
        Online: 'ออนไลน์', Offline: 'ออฟไลน์',
      },
      {
        Online: 'light-success', Offline: 'light-danger',
      }],
      ISNormal: [{
        Online: 'ปกติ', Offline: 'ผิดปกติ',
      },
      {
        Online: 'success', Offline: 'danger',
      }],
      SemISOnline: [{
        Online: 'ออนไลน์', Offline: 'ออฟไลน์',
      },
      {
        Online: 'light-success', Offline: 'light-danger',
      }],
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getMenu4G()
    this.interval = setInterval(() => {
      this.getMenu4G()
    }, 1000)
  },
  methods: {
    getMenu4G() {
      axios
        .post('/getMenu4G-Sub', { DeptID: this.$route.query.DeptID })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
  // .leaflet-container a.leaflet-popup-close-button {
  //   padding: 0 0 0 0
  // }
</style>
